import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetUserResponse } from "../interfaces/response/get-user-response.interface";
import { Rol } from "../interfaces/rol.interface";
import { User } from "../../../interfaces/user.interface";
@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpClient) {}

  private cantidadDeRegistros: number = 20; //es la cantidad de registros que retornara el servicio

  getByToken(token: string): Observable<User> {
    const headers = new HttpHeaders({
      Authorization: `Token ${token}`,
    });

    return this.http.get<User>(`${environment.apiBase}/accounts/get_user/`, {
      headers,
    });
  }

  getUsers(page: number | string): Observable<GetUserResponse> {
    return this.http.get<GetUserResponse>(
      `${environment.apiBase}/v1/user/?cant=${this.cantidadDeRegistros}&page=${page}`,
    );
  }

  getByFilters(data: { filter: any }): Observable<User[]> {
    return this.http.post<User[]>(
      `${environment.apiBase}/v1/user/by_filters/`,
      data,
    );
  }

  getRol(tokenRol: string): Observable<Rol> {
    return this.http.get<Rol>(`${environment.apiBase}/v1/rol/${tokenRol}`);
  }

  buscador(parametros: string, page: number): Observable<GetUserResponse> {
    return this.http.post<GetUserResponse>(
      `${environment.apiBase}/v1/user/buscar`,
      { parametros: parametros, cant: this.cantidadDeRegistros, page: page },
    );
  }

  put(user: User): Observable<User> {
    return this.http.put<User>(
      `${environment.apiBase}/v1/user/${user.token}`,
      user,
    );
  }

  get(token: string): Observable<User> {
    return this.http.get<User>(`${environment.apiBase}/v1/user/${token}`);
  }

  crear(data: { username: string; email: string; password: string }): Observable<User> {
    return this.http.post<User>(`${environment.apiBase}/v1/users/`, data);
  }
}
